import { useEffect } from 'react';
import * as Main from '~/pages/Main/index.styled';
import { FlexStack } from '~/components/atomic';
import { FullScreenLoading } from '~/components/common';
import { useGetSearchCharacterListQuery } from '~/features/character';
import {
  useCharacterLikeActions,
  useCreateChatRoom,
  useIntersectionObserver,
} from '~/hooks';
import ExploreCharactersView from './ExploreCharactersView';

export default function ExploreCharacters() {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.1,
  });
  const {
    data: allList,
    isFetchingNextPage,
    fetchNextPage,
  } = useGetSearchCharacterListQuery({});

  useEffect(() => {
    if (isIntersecting) {
      fetchNextPage();
    }
  }, [isIntersecting]);

  const { handleLikeClick } = useCharacterLikeActions();
  const { handleCreateRoomClick, isCreateRoomPending } = useCreateChatRoom();

  return (
    <>
      {isCreateRoomPending && <FullScreenLoading />}

      <FlexStack>
        <Main.SubTitle>Explore</Main.SubTitle>
        <ExploreCharactersView
          characterList={allList.pages}
          handleCardClick={handleCreateRoomClick}
          handleLikeClick={handleLikeClick}
          isFetchingNextPage={isFetchingNextPage}
        />
        {!isFetchingNextPage && <div ref={ref} />}
      </FlexStack>
    </>
  );
}
